import sheerId from 'https://cdn.jsdelivr.net/npm/@sheerid/jslib@2/sheerid-install.js';

function displayVerificationArtist(e) {
  e.preventDefault();
  sheerId.loadInModal(
    'https://services.sheerid.com/verify/6903c7504161ab46557c4607/',
    {
      mobileRedirect: false,
      closeButtonText: "Close",
    },
  );
}

function displayVerificationStudent(e) {
  e.preventDefault();
  sheerId.loadInModal(
    'https://services.sheerid.com/verify/6998cbfa18d38659dbfffd22/',
    {
      mobileRedirect: false,
      closeButtonText: "Close",
    },
  );
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".modal-button-artist").forEach(el => el.addEventListener("click", displayVerificationArtist));
  document.querySelectorAll(".modal-button-student").forEach(el => el.addEventListener("click", displayVerificationStudent));
});
